import React, { Component } from "react";
import Concert from "./concert";
import "./concert.css";

import ScrollIndicator from "./ScrollIndicator.jsx";

/* Here is what is displayed on top, first of all */
const openingSection = (
  <div className="program-heading">
    <center>
      <h1>Varmt välkomna till Folkmusikkaféet</h1>
      Vi är en mötesplats för levande folkmusik och dans i Göteborg.
      <br />
      Folkmusik och dans varje fredag.
      <br />
      <br />
      <small>
        Bli medlem och få rabatt på inträdet. Du bidrar till att vi finns!
        <br />
        Du blir medlem i entrén på en konsertkväll
        <br /> eller genom att sätta in 50 kr på PG 107741-1, alt. Swish
        1236279434. <br />
        Ange namn, adress, telefonnummer och e-postadress.
        <br />
        Medlemskap gäller per kalenderår.
        <br />
        <br />
        Konsertbiljetter köpes i entrén. Ungdomar och studenter får rabatt.
        Efter avslutad konsert får alla det lägre entrépriset. Ingen förbokning,
        förutom de kvällar där det står ”För den här kvällen finns förköp”.
        <br />
        Spel och danskvällarna, heldanskvällen och spelmansstämman har Fri
        entré.
        <br />
      </small>
    </center>
  </div>
);

/* Here the program is inserted! */
const theProgram = [
  <Concert
    title="Spel- och danskväll"
    date="2026-09-18"
    cost={0}
    img="img/program/ht2026/spel_och_dans_sep.jpg"
    cafeHost="Hisingens spelmanslag"
  >
    <div className="pBody">
      <center>
        Frivillig entréavgift.
        <br />
        <br />
        Folkmusikkaféet inleder höstsäsongen med en spel- och danskväll – dans
        till spellista. Tre grupper är bokade att inleda kvällen, sedan är det
        fritt fram att skriva upp sig på listan.
        <br />
        <br />
        Den här kvällen börjar FMK:s nybörjarkurs i dans. Första tillfället är
        gratis och kräver ingen förbokning. Du kan alltså komma första gången
        och prova på, och därefter bestämma om du vill fortsätta kursen eller
        inte. Mats Nilsson och Ingegerd Sigfridsson lär ut grundpolska, Staffan
        Folestad spelar.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Tillsammansgruppen</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>
              Danskurs för nybörjare, första tillfället är gratis och kräver
              ingen förbokning.
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Visstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Kenneth Dalbris lär ut folkvisor från Västsverige.</small>
            </td>
          </tr>
          <tr>
            <td>20:00–21:30</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Triol, Hisingens spelmanslag och Fredrik Persson.</small>
            </td>
          </tr>
          <tr>
            <td>21:30–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Öppen spellista.</small>
            </td>
          </tr>
        </table>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Väsen"
    date="2026-09-25"
    cost={180}
    costYoung={95}
    img="img/program/ht2026/vasen.jpg"
    prebook="https://billetto.se/e/vasen-biljetter-1983813"
    cafeHost="Styrelsen + medarbetare"
  >
    <div className="pBody">
      <center>
        Väsen, Mikael Marin och Olov Johansson, har under mer än 40 års
        intensivt samspel och turnerande renodlat sitt sound och sin sceniska
        närvaro till den grad att de i dag är unika i sitt slag. Med sitt
        lekfulla och fulländade samspel verkar de trotsa fysikens lagar i något
        som förefaller vara en telepatisk kommunikation. Musiken är intensiv,
        dynamisk och fylld av humor. Med hjälp av stundens inspiration skapar de
        ett helt eget musikaliskt språk som i sitt tilltal är lika modernt som
        ålderdomligt.
        <br />
        <br />
        <b>
          OBS! För den här kvällen kan du{" "}
          <a
            href="https://billetto.se/e/vasen-biljetter-1983813"
            target="_blank"
            rel="noopener noreferrer"
          >
            köpa biljetter i förväg via Billetto
          </a>{" "}
          (avgift tillkommer).
        </b>
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs för nybörjare</td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Håkan och Ingela Lindberg lär ut slängpolska. Spelman: Björn
                Johnsson.
              </small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Visstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Mikael Rittri lär ut sina favoritvisor (och lär sig era).
              </small>
            </td>
          </tr>
          <tr>
            <td>20:00–21:00</td>
            <td>Konsert: Väsen</td>
          </tr>
          <tr>
            <td>21:00–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Väsen.</small>
            </td>
          </tr>
          <tr>
            <td>I pausen</td>
            <td>Bagaregårdens spelmanslag spelar.</td>
          </tr>
        </table>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Täpp Ida Almlöf &amp; Erika Lindgren Liljenstolpe"
    date="2026-10-02"
    cost={160}
    costYoung={85}
    img="img/program/ht2026/tapp_ida_erika.jpg"
    cafeHost="Polskedanslaget"
  >
    <div className="pBody">
      <center>
        Täpp Ida Almlöf och Erika Lindgren Liljenstolpe har sina rötter i
        Dalarna respektive Uppland. Deras gemensamma nämnare är musiken från
        Bingsjö som de beskriver som magisk och suggestiv. Låtarna har de
        tillägnat sig på olika håll: Ida genom Päkkos Gustaf och Erika genom
        uppländske Bosse Larsson. Ida och Erika spelar också tillsammans i
        gruppen Systerpolskan, initierad av Benny Andersson.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs för nybörjare</td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Malte Hermansson och Kerstin Harvenberg lär ut bingsjöpolska.
                Spelmän: Håkan och Ingela Lindberg.
              </small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Visstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Ingrid Westerfors: Visor om hösten - vi lär och delar.
              </small>
            </td>
          </tr>
          <tr>
            <td>20:00–20:50</td>
            <td>Konsert: Täpp Ida och Erika</td>
          </tr>
          <tr>
            <td>20:50–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Täpp Ida och Erika.</small>
            </td>
          </tr>
          <tr>
            <td>I pausen</td>
            <td>Fru Salt spelar.</td>
          </tr>
        </table>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Stordanskväll: Lunden samt Mia Marine"
    date="2026-10-09"
    cafeHost="Bagaregårdens spelmanslag"
    cost={160}
    costYoung={85}
    img="img/program/ht2026/lunden.jpg"
    imgTwo="img/program/ht2026/mia_marine.jpg"
  >
    <div className="pBody">
      <center>
        Lunden (Anna Lindblad, Olof Kennemark och Anders Löfberg): En stråktrio
        vars musik tar avstamp i den västgötska myllan men flyger fritt över
        gärden, genom skogen och ut över havet. Med tungt sväng, lätta stråk och
        ett obönhörligt driv leds publiken och dansgolvet genom polskor, valser
        och schottisar från Västergötland och nya kompositioner med influenser
        från Nordamerika.
        <br />
        <br />
        Mia Marine: Vi har många gånger fått dansa till hennes svängiga
        fiolspel. Det brukar bli blandade danser, med tonvikt på Värmland,
        Dalarna och Norge. Ett av hennes signum är dock att hon spelar polskor
        från många olika håll, med stor genrekunskap, självklart danssväng och
        en smittande spelglädje.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs för nybörjare</td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Erik Mägi och Emma Rydberg lär ut schottis. Spelman: Stina
                Huldén.
              </small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Spelstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Lars-Gunnar Franzén lär ut låtar efter Lejsme Per.</small>
            </td>
          </tr>
          <tr>
            <td>20:00–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Lunden samt Mia Marine.</small>
            </td>
          </tr>
        </table>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Alban Faust &amp; The Northern Winds Project"
    date="2026-10-16"
    cafeHost="Projekt Leila och Tageltrång"
    cost={160}
    costYoung={85}
    img="img/program/ht2026/alban_faust_northern_winds.jpg"
  >
    <div className="pBody">
      <center>
        Den samspelta kvartetten, varav två är riksspelmän, hyser en brinnande
        passion för den traditionella nordiska musiken. De kommer att bjuda på
        både vackra och medryckande musikstycken, med rötterna djupt förankrade
        i den västsvenska folkmusiktraditionen – känslosamt, tätt och nära.
        <br />
        <br />
        Alban Faust (nyckelharpa, säckpipa, gitarr, sång), Tomas Fredriksson
        (fiol), Ute Faust Thomas (klarinetter) och Sören Blom (bas).
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs för nybörjare</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Tillsammansgruppen</td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Spelstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Annelie Westerlund lär ut låtar från Västergötland.</small>
            </td>
          </tr>
          <tr>
            <td>20:00–20:50</td>
            <td>Konsert: Alban Faust &amp; The Northern Winds Project</td>
          </tr>
          <tr>
            <td>20:50–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Alban Faust &amp; The Northern Winds Project.</small>
            </td>
          </tr>
          <tr>
            <td>I pausen</td>
            <td>Kristians kapell spelar.</td>
          </tr>
        </table>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Heldanskväll"
    date="2026-10-23"
    cafeHost="Skjortor och särkar"
    cost={0}
    img="img/program/ht2026/heldanskvall.jpg"
  >
    <div className="pBody">
      <center>
        Frivillig entréavgift.
        <br />
        <br />
        En helkväll för alla dansare. Tagel &amp; Co, Urbanders och Höstrusk
        kommer att spela till dans två halvtimmar var. Vi kan räkna med att det
        blir mycket polskor men också några gammaldanser.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs för nybörjare, sista gången</td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Balkandansarna lär ut danser från Balkan. Spelmän: Joar Skorpen
                med vänner.
              </small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Visstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Robert Qvist lär ut visor från Ångermanland.</small>
            </td>
          </tr>
          <tr>
            <td>20:00–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Tagel &amp; Co, Urbanders och Höstrusk.</small>
            </td>
          </tr>
        </table>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Tron Steffen Westberg, Ole Erik Feragen &amp; Per Ivar Tamnes"
    date="2026-10-30"
    cafeHost="GNDS"
    cost={180}
    costYoung={95}
    img="img/program/ht2026/tron_westberg_feragen_tamnes.jpg"
  >
    <div className="pBody">
      <center>
        Trekløveret som spiller fredag kveld til konsert og dans har lang
        fartstid som formidlere av sin lokale tradisjon. De har spilt sammen i
        flere år i ulike sammenhenger og konstellasjoner, og har alle sin
        bakgrunn fra Brekken spellmannslag. Tradisjonen er Røros-tradisjonen og
        Rørospolsen er varemerket. Her blir det trykk og driv med to feler og
        gitar!
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs, fortsättning, första gången</td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Peter och Alice Nordqvist lär ut rørospols (viss dansvana
                krävs). Spelman: Joar Skorpen.
              </small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Spelstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Hans Grönlund lär ut låtar från östra Värmland.</small>
            </td>
          </tr>
          <tr>
            <td>20:00–20:50</td>
            <td>
              Konsert: Tron Steffen Westberg, Ole Erik Feragen &amp; Per Ivar
              Tamnes
            </td>
          </tr>
          <tr>
            <td>20:50–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Tron Steffen Westberg, Ole Erik Feragen &amp; Per Ivar Tamnes.
              </small>
            </td>
          </tr>
          <tr>
            <td>I pausen</td>
            <td>Gôtt &amp; blandat spelar.</td>
          </tr>
        </table>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Studenter på Högskolan för scen och musik"
    date="2026-11-06"
    cafeHost="Västkustfolk"
    cost={0}
    img="img/program/ht2026/hsm_studenter.jpg"
  >
    <div className="pBody">
      <center>
        Frivillig entréavgift.
        <br />
        <br />
        Studenterna på utbildningen i samtida traditionsmusik fördjupar sig i
        traditionell musik, överbryggar gränser och skapar nya samarbeten. I
        konserten möts färgstarka musiker från olika traditioner i nya uttryck.
        En kväll för både djup och danslust – vad som helst kan hända! Efteråt
        bjuds det in till traditionsenlig danskväll med folklig musik från när
        och fjärran.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs, fortsättning</td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Visstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Anders Ström lär ut isländska visor.</small>
            </td>
          </tr>
          <tr>
            <td>20:00–21:00</td>
            <td>Konsert: Studenter på Högskolan för scen och musik</td>
          </tr>
          <tr>
            <td>21:00–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Studenter på Högskolan för scen och musik.</small>
            </td>
          </tr>
        </table>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Lele Lele Orchestra"
    date="2026-11-13"
    cafeHost="Balkandansarna"
    cost={180}
    costYoung={95}
    img="img/program/ht2026/lele_lele_orchestra.jpg"
  >
    <div className="pBody">
      <center>
        Lele Lele Orchestra spelar bulgarisk folkmusik och balkan-romsk
        repertoar till ångande dansgolv såväl som för lyssnande publik. Bandets
        utgångspunkt är den bulgariska folkmusikens rika tradition av vindlande
        melodier, sentimentala sånger och halsbrytande rytmer i möte med hejdlös
        improvisation och lekfullt samspel med varandra och publiken.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs, fortsättning</td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Peter Nordqvist och Marie Schoonderwaldt lär ut grundpolska.
                Spelman: Sanna Rosengren.
              </small>
            </td>
          </tr>
          <tr>
            <td>20:00–20:45</td>
            <td>Konsert: Lele Lele Orchestra</td>
          </tr>
          <tr>
            <td>20:50–21:30</td>
            <td>I pausen spelar Västkustfolk till dans (svenskt)</td>
          </tr>
          <tr>
            <td>21:30–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>
                Lele Lele Orchestra (enkel dansinstruktion första halvtimman).
              </small>
            </td>
          </tr>
        </table>
        <br />
        <small>Kvällen arrangeras i samarbete med Balkandansarna.</small>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Spel- och danskväll"
    date="2026-11-20"
    cafeHost="Mams &amp; Paps"
    cost={0}
    img="img/program/ht2026/spel_och_dans_nov.jpg"
  >
    <div className="pBody">
      <center>
        Frivillig entréavgift.
        <br />
        <br />
        På en spel- och danskväll är det dans till spellista. Vi har bokat musik
        som inleder kvällen, sedan är det fritt fram att skriva upp sig på
        listan.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Tillsammansgruppen</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs, fortsättning</td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Spelstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Håkan Bengtsson lär ut låtar från Hälsingland.</small>
            </td>
          </tr>
          <tr>
            <td>20:00–21:30</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Lei-la, Tageltrång och Mams &amp; Paps.</small>
            </td>
          </tr>
          <tr>
            <td>21:30–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Öppen spellista.</small>
            </td>
          </tr>
        </table>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Folkklubb x Folkmusikkaféet"
    date="2026-11-27"
    cafeHost="Folk Youth VG"
    cost={180}
    costYoung={95}
    img="img/program/ht2026/trasket.jpg"
    imgTwo="img/program/ht2026/storrada.jpg"
    imgTwoLink="https://www.instagram.com/storradamusic"
  >
    <div className="pBody">
      <center>
        Folkmusikkaféet och Folk Youth Västra Götaland bjuder in till Folkklubb
        i akustisk tappning – en kväll med unga stjärnskott på folkmusikscenen.
        <br />
        <br />
        Vi får höra konserter med Träsket (saxofonisterna Stina Huldén och Hilda
        Ekstedt samt klarinettisterna Albin Myrin och Veronica Lindåker) och
        Storråda (Alma Strang Brydevall, fioler, Pella Wig, sång och fiol, och
        Olle Westling, gitarr). Mellan konserterna blir det dans till ALFV Duo
        (Agnes Lax och Filip Vari, fioler), och efter konserterna spelar
        artisterna vidare till dans.
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs, fortsättning</td>
          </tr>
          <tr>
            <td>19:00–19:45</td>
            <td>Dansstuga för vana och ovana dansare</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Med Folkdanssällskapet Nationals Ungdomslag.</small>
            </td>
          </tr>
          <tr>
            <td>20:00–20:50</td>
            <td>Konsert: Träsket</td>
          </tr>
          <tr>
            <td>20:50–21:30</td>
            <td>Dans till ALFV</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Ovanvåningen.</small>
            </td>
          </tr>
          <tr>
            <td>21:30–22:20</td>
            <td>Konsert: Storråda</td>
          </tr>
          <tr>
            <td>22:20–00:00</td>
            <td>Dans till artisterna</td>
          </tr>
        </table>
        <br />
        <small>Arrangeras i samarbete med Folk You och Folk Youth VG.</small>

        <br />
        <br />
        <img
          style={{ maxWidth: "30%" }}
          src="img/arkiv/folkyou.png"
          alt="folkyou"
        ></img>
        <img
          src="img/arkiv/FY_VG_color.png"
          style={{ width: "30%" }}
          onClick={() =>
            window.open("https://www.goteborgfolkfestival.com/folkyouth")
          }
      ></img>
      </center>
    </div>
  </Concert>,

  <Concert
    title="Julkonsert &amp; dans: Midvinterfôlk"
    date="2026-12-04"
    cafeHost="Styrelsen + medarbetare"
    cost={180}
    costYoung={95}
    img="img/program/ht2026/midvinterfolk.jpg"
  >
    <div className="pBody">
      <center>
        Med gamla folkvisor och snåriga melodier av skickliga musiker och
        sångare bjuds publiken på en resa tillbaka i tiden – till en tid då
        gemenskap och tradition stod i centrum. Repertoaren består inte av de
        mest spelade julvisorna, här ryms Staffansvisor, fartfyllda
        traditionella låtar och jultrallar som nästan fallit i glömska. Bandet
        består av sex musiker och sångare från norra Bohuslän: Christer Ådin,
        Frank Boberg, Cecilia Wingård, Anders Ådin, Richard Wirdeson och Björn
        Regnér.
        <br />
        <br />
        <b>
          OBS! För den här kvällen finns förköp via Billetto, se FMK:s hemsida
          (avgift tillkommer).
        </b>
        <br />
        <br />
        <table className="program-tabell">
          <tr>
            <td>17:30–19:15</td>
            <td>Kurs: Spelmanslaget</td>
          </tr>
          <tr>
            <td>18:00–19:30</td>
            <td>Danskurs, fortsättning, sista gången</td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Dansstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>RSCDS Gothenburg lär ut skotska danser.</small>
            </td>
          </tr>
          <tr>
            <td>18:30–19:30</td>
            <td>Visstuga</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Ann-Britt Lindhult lär ut visor inför julen.</small>
            </td>
          </tr>
          <tr>
            <td>20:00–21:00</td>
            <td>Konsert: Midvinterfôlk</td>
          </tr>
          <tr>
            <td>21:00–23:00</td>
            <td>Spel till dans</td>
          </tr>
          <tr>
            <td></td>
            <td>
              <small>Midvinterfôlk.</small>
            </td>
          </tr>
        </table>
      </center>
    </div>
  </Concert>,
];

const FadeInSection = ({ children }) => {
  const domRef = React.useRef();

  const [isVisible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const currentRef = domRef.current;
    if (!currentRef) {
      return undefined;
    }

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setVisible(true);
        observer.unobserve(currentRef);
      }
    });

    observer.observe(currentRef);

    if (currentRef) {
      return () => observer.unobserve(currentRef);
    }
  }, []);

  return (
    <section
      ref={domRef}
      className={isVisible ? "entrySec is-visible" : "entrySec"}
    >
      {children}
    </section>
  );
};

class Program extends Component {
  styles = {
    fontSize: 15,
    fontWeight: "bold",
  };

  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
      latest: null,
    };
    this.sortArchive();
  }

  getProgram() {
    return theProgram;
  }

  sortArchive() {
    theProgram.sort((a, b) => {
      let dateDiff = a.props.date.localeCompare(b.props.date);
      if (dateDiff < 0) {
        return -1;
      } else if (dateDiff > 0) {
        return 1;
      }
      return 0;
    });
  }

  render() {
    let theProgramCopy = [...theProgram];
    let scrollIndicator = <ScrollIndicator />;

    while (theProgramCopy.length > 0) {
      let p = new Concert(theProgramCopy[0].props);
      if (!p.dateOK()) {
        theProgramCopy.shift();
      } else {
        break;
      }
    }

    if (theProgramCopy.length === 0) {
      return (
        <div>
          {openingSection}
          <center>
            <h1>Tack för denna säsong!</h1>
            Hoppas vi ses även nästa. Vi kommer snart att presentera kommande
            program.
            <br />
            <br />
            <a href="/arkiv">Vårt arkiv över tidigare kvällar som varit</a>
            <br />
            <br />
          </center>
        </div>
      );
    }

    if (theProgramCopy.length > 1) {
      let prog = [...theProgramCopy];
      let firstShow = prog.shift();
      /* All except the first one should have this swooch effect */
      let items = prog.map((concert) => (
        <FadeInSection key={concert}>{concert}</FadeInSection>
      ));
      items.unshift(<div className="is-visible">{firstShow}</div>);
      return (
        <div>
          {scrollIndicator}
          {openingSection}
          {items}
          <br />
          <center>
            <a
              style={{
                "font-size": "30px",
                border: "1px solid black",
                padding: "10px",
                "border-radius": "5px",
              }}
              href="/arkiv"
            >
              Tidigare program
            </a>
          </center>
          <br />
          <br />
          <br />
        </div>
      );
    }
    return (
      <div>
        {openingSection}
        {theProgram}
        <center>
          <a
            style={{
              "font-size": "30px",
              border: "1px solid black",
              padding: "10px",
              "border-radius": "5px",
            }}
            href="/arkiv"
          >
            Tidigare program
          </a>
        </center>
        <br />
        <br />
      </div>
    );
  }
}

export default Program;
